export default "__VITE_ASSET__BREmMbMx__"